export const PRACTICIONER = '/practitioner/practitioners/:practitionerId';
